import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import gstLogo from "../assets/images/logo/gstb_logo.svg";
import LoginModal from "../components/Login";
import ProfileMenu from "../components/common/ProfileMenu";
import { useSelector } from "react-redux";

const Header = () => {
  const token = localStorage.getItem("GSTB_token");
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const { user } = useSelector((state) => state.USER_DATA);

  return (
    <header className="site-header">
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container">
          {/* Logo */}
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img src={gstLogo} alt="GSTB Logo" className="brand-logo" />
          </Link>

          {/* Mobile/Tablet Toggler (visible < 992px) */}
          <button
            className="navbar-toggler d-lg-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileOffcanvas"
            aria-controls="mobileOffcanvas"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* DESKTOP NAVBAR (visible only on large screens) */}
          <div
            className="collapse navbar-collapse d-none d-lg-flex"
            id="mainNavbar"
          >
            <ul className="navbar-nav mx-auto text-center inter-medium justify-content-end">
              <li className="nav-item">
                <NavLink className="nav-link" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about_us">
                  About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/committee">
                  Meet Our Teams
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/events"
                // style={{ opacity: 0.5, cursor: "not-allowed" }}
                // onClick={(e) => {
                //   e.preventDefault();
                //   e.stopPropagation();
                // }}
                >
                  Events
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink
                  className="nav-link"
                  //  to="/events"
                >
                  Events
                </NavLink>
              </li> */}

              {/* <li className="nav-item">
                <NavLink className="nav-link" to="/bylaws">
                  ByLaws
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/events-gallery"
                // style={{ opacity: 0.5, cursor: "not-allowed" }}
                // onClick={(e) => {
                //   e.preventDefault();
                //   e.stopPropagation();
                // }}
                >
                  Events Gallery
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink className="nav-link" to="/committee">
                  Committee
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink className="nav-link " to="/rsvp">
                  RSVP
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink className="nav-link" to="/sponsor">
                  Sponsor
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink className="nav-link" to="/membership">
                  Membership
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact_us">
                  Contact Us
                </NavLink>
              </li>
              {!token ? (
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-login ms-lg-3"
                    onClick={() => setIsLoginOpen(true)}
                  >
                    Login
                  </button>
                </div>
              ) : (
                <div className="d-flex align-items-center ms-3">
                  <ProfileMenu user={user} />
                </div>
              )}
            </ul>
          </div>

          {/* MOBILE & TABLET OFFCANVAS (right side) */}
          <div
            className="offcanvas offcanvas-end d-lg-none"
            tabIndex="-1"
            id="mobileOffcanvas"
            aria-labelledby="mobileOffcanvasLabel"
          >
            <div className="offcanvas-header py-2">
              <Link className="navbar-brand d-flex align-items-center" to="/">
                <img src={gstLogo} alt="GSTB Logo" className="brand-logo" />
              </Link>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>

            <div className="offcanvas-body">
              <ul className="navbar-nav text-start inter-medium">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/">
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/about_us">
                    About Us
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/committee">
                    Meet Our Teams
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/events">
                    Events
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/bylaws">
                    ByLaws
                  </NavLink>
                </li> */}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/events-gallery">
                    Events Gallery
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/committee">
                    Committee
                  </NavLink>
                </li> */}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/rsvp">
                    RSVP
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink className="nav-link" to="/sponsor">
                    Sponsors
                  </NavLink>
                </li> */}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/membership">
                    Membership
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/contact_us">
                    Contact us
                  </NavLink>
                </li>
              </ul>

              {!token ? (
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-login ms-lg-3"
                    onClick={() => setIsLoginOpen(true)}
                  >
                    Login
                  </button>
                </div>
              ) : (
                <div className="d-flex align-items-center ms-3">
                  <ProfileMenu user={user} />
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
      {isLoginOpen && (
        <LoginModal
          isOpen={isLoginOpen}
          onClose={() => setIsLoginOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;
